import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Button from './Button';
import Modal from './Modal';
import styled from 'styled-components';
import { PhoneFilled, MailOutlined } from '@ant-design/icons';
import { FINLAND, NORWAY, SWEDEN } from '../constants/CountryCodes';
import { Fi, No, Se } from 'react-flags-select';


const PhoneIcon = styled(PhoneFilled)`
margin-right: 10px;
color: white;
`;
const MailIcon = styled(MailOutlined)`
margin-right: 10px;
color: white;
`;

const ContactModal = ({ confirmModalOpen, setConfirmModalOpen, countryCode, isLoginPage }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!confirmModalOpen) {
      return undefined;
    }
    const timerId = window.setTimeout(() => {
      setConfirmModalOpen(false);
    }, 60000);
    return () => window.clearTimeout(timerId);
  }, [ confirmModalOpen, setConfirmModalOpen ]);


  const countryInfo = [
    {
      countryCode: SWEDEN,
      countryFlag: <Se />,
      email: t('contact.country.sv.email'),
      phone: t('contact.country.sv.phone'),
    },
    {
      countryCode: FINLAND,
      countryFlag: <Fi />,
      email: t('contact.country.fi.email'),
      phone: t('contact.country.fi.phone'),
    },
    {
      countryCode: NORWAY,
      countryFlag: <No />,
      email: t('contact.country.no.email'),
      phone: t('contact.country.no.phone'),
    },
  ];

  const modalContent = countryCode ?
    countryInfo.filter(info => info.countryCode === countryCode) : Object.values(countryInfo);

  return (<Modal
    title={t('contact.title')}
    visible={confirmModalOpen}
    centered={true}
    width="700px"
    closable={false}
    footer={[ <Button key="close" type="primary" onClick={() => setConfirmModalOpen(false)}>
      {t('close')}
    </Button> ]}
    onCancel={() => setConfirmModalOpen(false)}
  >
    <div className="contactInformation">
      {Array.isArray(modalContent) ? modalContent.map((data, index) => (<React.Fragment key={index}>
        <p> {isLoginPage && <span className="flag-icon">{data.countryFlag}</span>} <MailIcon />{data.email}</p>
        <p> {isLoginPage && <span className="flag-icon">{data.countryFlag}</span>} <PhoneIcon />{data.phone}</p>
      </React.Fragment>)) : (<>
        <p><MailIcon />{modalContent.email}</p>
        <p><PhoneIcon />{modalContent.phone}</p>
      </>)}
    </div>
  </Modal>);
};

export default ContactModal;
